import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Header from '../../components/Header';
import BuilderTab from './BuilderTab';
import ChannelWidgetHtml from '../../components/Builder/Channels/ChannelWidgetHtml';
import AvailableChannels from '../../components/Builder/Channels/AvailableChannels';
import AvailableIa from '../../components/Intelligence/AvailableIa';
import SettingsTab from './SettingsTab';
import Overview from './Overview';
import Analyze from './Analyze/Analyze';
import BotReportMainScreen from './Analyze/BotReport/BotReportMainScreen';
import ChannelWhatsApp from '../../components/Builder/Channels/ChannelWhatsApp';
import ChannelBar from '../../components/Builder/Channels/ChannelBar';
import ChannelFacebookMessenger from '../../components/Builder/Channels/ChannelFacebookMessenger';
import ChannelConfigSecurity from '../../components/Builder/Channels/ChannelConfigSecurity';

function Builder(props) {
  const { match } = props;

  return (
    <>
      <Header pagetype="page-criador" {...props} />
      <Switch>
        <Route
          exact
          path={`${match.url}/:botid/overview`}
          component={Overview}
        />
        <Route
          exact
          path={`${match.url}/:botid/criador`}
          component={BuilderTab}
        />
        {/* <Route exact path={`${match.path}/canais/:botid`} component={Channels} render={() => {this.setState({currentmenu: 'canais'})}} /> */}
        <Route
          exact
          path={`${match.url}/:botid/configuracoes`}
          component={SettingsTab}
        />
        <Route
          exact
          path={`${match.url}/:botid/analise`}
          component={BotReportMainScreen}
        />
        <Route
          exact
          path={`${match.url}/:botid/inteligencia`}
          component={AvailableIa}
        />
        <Route
          exact
          path={`${match.url}/:botid/canais`}
          component={AvailableChannels}
        />
        <Route
          exact
          path={`${match.url}/:botid/canais/widget-html`}
          component={ChannelWidgetHtml}
        />
        <Route
          exact
          path={`${match.url}/:botid/canais/whatsapp`}
          component={ChannelWhatsApp}
        />
        <Route
          exact
          path={`${match.url}/:botid/canais/facebook-messenger`}
          component={ChannelFacebookMessenger}
        />
        <Route
          exact
          path={`${match.url}/:botid/canais/barra-de-canais`}
          component={ChannelBar}
        />
        <Route
          exact
          path={`${match.url}/:botid/canais/configuracao-lgpd`}
          component={ChannelConfigSecurity}
        />
      </Switch>
    </>
  );
}

export default Builder;
